class Api {
  baseUrl = '';
  setAuthHook = null;
  onApiError = null;

  constructor(baseUrl) {
    if (!baseUrl) {
      throw new Error('Invalid url');
    }
    this.baseUrl = baseUrl;
  }

  setAuth(hook) {
    this.setAuthHook = hook;
  }

  login(login, password) {
    return this.doRequest('/login', 'POST', {
      login: login,
      password: password,
    });
  }

  getFeeds(from, to, timezone, disableRemoteStats) {
    return this.doRequest(`/feeds?from=${from}&to=${to}&timezone=${timezone}&disableRemoteStats=${disableRemoteStats}`, 'GET');
  }

  getChangelogs() {
    return this.doRequest(`/changelogs`, 'GET');
  }

  getCampaigns(params) {
    const obj = {
      page: params.page,
      perPage: params.perPage,
    };

    if (params.sort) {
      obj['sort.field'] = params.sort.field;
      obj['sort.type'] = params.sort.type;
    }

    const searchParams = new URLSearchParams(obj);

    for (const field in params.columnFilters) {
      searchParams.append(`filter.${field}`, params.columnFilters[field]);
    }

    return this.doRequest(`/campaigns?${searchParams.toString()}`, 'GET');
  }

  getFeed(id) {
    return this.doRequest(`/feeds/${id}`, 'GET');
  }

  createFeed(feed) {
    return this.doRequest(`/feeds`, 'POST', feed);
  }

  updateFeed(feed) {
    return this.doRequest(`/feeds/${feed.id}`, 'PUT', feed);
  }

  saveFeed(feed) {
    if (feed.id) {
      return this.updateFeed(feed);
    } else {
      return this.createFeed(feed);
    }
  }

  getVariables() {
    return this.doRequest(`/variables`, 'GET');
  }

  getTypes() {
    return this.doRequest(`/types`, 'GET');
  }

  getStatistics(filters) {
    const searchParams = new URLSearchParams(filters);
    return this.doRequest(`/statistics?${searchParams.toString()}`, 'GET');
  }

  getParsers() {
    return this.doRequest(`/parsers`, 'GET');
  }

  getBrowsers() {
    return this.doRequest(`/browsers`, 'GET');
  }

  blockCampaign(id) {
    return this.doRequest(`/campaigns/${id}/block`, 'POST');
  }

  unblockCampaign(id) {
    return this.doRequest(`/campaigns/${id}/unblock`, 'POST');
  }

  getTimezones() {
    return this.doRequest(`/timezones`, 'GET');
  }

  doRequest(path, method, body) {
    let headers = {};
    if (typeof this.setAuthHook === 'function') {
      headers = this.setAuthHook(headers);
    }
    return fetch(`${this.baseUrl}${path}`, {
      method: method,
      body: body ? JSON.stringify(body) : null,
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
    }).then(async res => {
      const data = await res.json();

      if (!res.ok) {
        return Promise.reject({
          data: data,
          status: res.status,
          message: data.message || data.error || res.status,
        });
      }

      return data;
    }).catch(e => {
      if (this.onApiError) {
        this.onApiError(e);
      }
      throw e;
    });
  }
}

export default Api;
